import React from 'react'
import '../assets/style.css'
class RedirectToHomeComponent extends React.Component {
  render () {
    return (
      <div className='container-tooltip' style={styles.iconContent}
        onClick={this.props.onClick}>
        <img className='img-tooltip' src={this.props.img} alt='true' style={styles.icon} />
        <span className='tooltiptext'>Rediriger vers home</span>
      </div>
    )
  }
}

const styles = {
  iconContent: {
    height: '48px',
    maxWidth: '56px',
    margin: 'auto'
  },
  icon: {
    cursor: 'pointer',
    marginTop: '10px',
    width: '28px',
    height: '28px',
    marginBottom: '-6px'
  }
}

export default RedirectToHomeComponent
